import { Grid2, Typography } from "@mui/material";
import {
  paymentDetailVeteransAffairsEnumMap,
  paymentMethodEnumMap,
  paymentTermsAndAgreement,
  PaymentTermsAndCondition,
} from "../enum/formEnum";
import React from "react";

const PaymentBaseRateDetails = ({ formData }) => {
  const paymentDetailsLabels = {
    baseRate: "Base Rate (Per Hour)",
    veteransAffairs:
      "Do you plan to use Veterans Affairs (VA) benefits to pay for or support your care?",
    signatureInfo: "Payment Agreement",
    paymentMethod: "Payment Method",
  };
  return (
    <>
      <Typography variant="h4" color="default.main">
        Payment Details
      </Typography>
      <Grid2 container spacing={1} mt={3}>
        {/* Loop over the top-level fields in paymentDetailsSection0 */}
        {Object.entries(paymentDetailsLabels).map(([key, label]) => {
          let formattedValue = "N/A";
          const value = formData?.paymentDetailsSection0?.[key];

          if (label === "Payment Agreement") {
            const signature =
              formData?.paymentDetailsSection0?.signatureInfo?.signature;
            const signerName =
              formData?.paymentDetailsSection0?.signatureInfo?.NameOfSigner;

            return (
              <React.Fragment key={key}>
                <Grid2 size={{ xs: 12, sm: 12 }}>
                  <Typography variant="body2" color="default.main" mb={0.5}>
                    Payment Agreement
                  </Typography>
                  <Typography
                    variant="body1"
                    color="default.light"
                    dangerouslySetInnerHTML={{
                      __html: paymentTermsAndAgreement["description"],
                    }}
                  ></Typography>
                </Grid2>

                <Grid2 size={{ xs: 12, sm: 6 }}>
                  <Typography variant="body2" color="default.main" mb={0.5}>
                    Signature
                  </Typography>
                  {signature ? (
                    <img
                      src={signature}
                      alt="Signature"
                      style={{ maxWidth: "100%", maxHeight: "200px" }}
                    />
                  ) : (
                    <Typography variant="body1" color="default.light">
                      No signature provided
                    </Typography>
                  )}
                </Grid2>

                <Grid2 size={{ xs: 12, sm: 6 }}>
                  <Typography variant="body2" color="default.main" mb={0.5}>
                    Name of Signer
                  </Typography>
                  <Typography variant="body1" color="default.light">
                    {signerName || "-"}
                  </Typography>
                </Grid2>
              </React.Fragment>
            );
          }

          switch (label) {
            case "Base Rate (Per Hour)":
              formattedValue = value ? `$ ${value}` : "N/A";
              break;
            case "Do you plan to use Veterans Affairs (VA) benefits to pay for or support your care?":
              formattedValue =
                paymentDetailVeteransAffairsEnumMap[value] ?? "N/A";
              break;
            case "Payment Method":
              formattedValue = paymentMethodEnumMap[value]
                ? paymentMethodEnumMap[value]
                : "N/A";
              break;
            default:
              formattedValue = value || "N/A";
              break;
          }
          return (
            <Grid2 size={{ xs: 12, sm: 12 }} key={key}>
              <Typography variant="body2" color="default.main" mb={0.5}>
                {label}
              </Typography>

              <Typography
                variant="body2"
                color="text.secondary"
                paragraph
                sx={{ whiteSpace: "pre-line" }}
              >
                {formattedValue}
              </Typography>
            </Grid2>
          );
        })}
        {PaymentTermsAndCondition.map((termsAndCondition, index) => {
          const paymentMethod = formData?.paymentDetailsSection0?.paymentMethod;

          if (paymentMethod === termsAndCondition.paymentMethod) {
            const agreementValue =
              formData?.paymentDetailsSection0?.[termsAndCondition.fieldKey]?.[
                termsAndCondition.agreementKey
              ];

            return (
              <Grid2 xs={12} sm={12} key={index} mb={1}>
                <Typography variant="body2" color="default.main" mb={0.5}>
                  {termsAndCondition.title}
                </Typography>

                <Typography
                  variant="body2"
                  color="text.secondary"
                  paragraph
                  sx={{ whiteSpace: "pre-line" }}
                  mb={0.5}
                >
                  {termsAndCondition.description}
                </Typography>

                <Typography variant="body1" color="secondary.dark" mt={1}>
                  {agreementValue === true
                    ? `Yes, I agree to the ${termsAndCondition.title}`
                    : `No, I do not agree to the ${termsAndCondition.title}`}
                </Typography>
              </Grid2>
            );
          }
          return null;
        })}
      </Grid2>
    </>
  );
};
export default PaymentBaseRateDetails;
